export default __webpack_public_path__ + "static/media/standard.0bf123c9.svg";